/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/undefined/ngm-portal-jws/public/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "Hpnf");
/******/ })
/************************************************************************/
/******/ ({

/***/ "D8yW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/@ali/fast-utils/dist/cookie.js
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * 默认属性
 * @hidden
 */
var DEFAULT_ATTRIBUTES = {
    path: '/',
};
/**
 * 敏感符号转换
 * ; <=> %3B
 * @hidden
 */
var converter = {
    read: function (value) {
        return value.replace(/%3B/g, ';');
    },
    write: function (value) {
        return value.replace(/;/g, '%3B');
    },
};
/**
 * 设置 Cookie
 *
 * ```js
 * FastUtils.setCookie('key', 'value'); // => key=value; path=/;
 *
 * // 有效期7天
 * FastUtils.setCookie('key', 'value', { expires: 7 }); // => key=value; path=/; expires=Fri, 26 Jun 2020 08:26:36 GMT;
 *
 * // 在本域名以及所有子域名下有效
 * FastUtils.setCookie('key', 'value', { domain: '.yourDomain.com' });
 * ```
 *
 * @category Cookie
 * @param key
 * @param value
 * @param attributes
 * @returns The cookie string assigned to document.cookie
 */
function setCookie(key, value, attributes) {
    if (!key)
        return '';
    attributes = __assign(__assign({}, DEFAULT_ATTRIBUTES), attributes);
    // if (typeof attributes.expires === 'number') {
    //   attributes.expires = new Date(Date.now() + attributes.expires * 864e5).toUTCString();
    // }
    key = converter.write(key).replace(/=/g, '%3D');
    value = converter.write(value);
    var stringifiedAttributes = '';
    Object.keys(attributes).forEach(function (attributeName) {
        var attributeValue = attributes[attributeName];
        if (!attributeValue)
            return;
        stringifiedAttributes += '; ' + attributeName;
        if (attributeValue === true)
            return;
        if (attributeName === 'expires' && typeof attributeValue === 'number') {
            // 将过期天数转换成UTC时间字符串
            var expireDate = new Date(Date.now() + attributeValue * 864e5).toUTCString();
            return (stringifiedAttributes += '=' + expireDate.split(';')[0]);
        }
        stringifiedAttributes += '=' + attributeValue.split(';')[0];
    });
    return (document.cookie = key + '=' + value + stringifiedAttributes);
}
/**
 * 获取 Cookie
 *
 * ```js
 * FastUtils.getCookie('key'); // => 'value'
 * FastUtils.getCookie('nothing'); // => undefined
 *
 * // 获取所有 cookie
 * FastUtils.getCookie(); // => { key: 'value' }
 * ```
 *
 * @category Cookie
 * @param key
 */
function getCookie(key) {
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var cookiesData = {};
    for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');
        var foundKey = converter.read(parts[0]).replace(/%3D/g, '=');
        cookiesData[foundKey] = converter.read(value);
        if (key === foundKey) {
            break;
        }
    }
    if (key) {
        return cookiesData[key];
    }
    return cookiesData;
}
/**
 * 删除 Cookie
 *
 * ```js
 * FastUtils.setCookie('key', 'value');
 * FastUtils.removeCookie('key');
 * FastUtils.getCookie('key'); // => undefined
 *
 * // 删除指定 domain / path 下的 Cookie 的正确方式
 * FastUtils.setCookie('key', 'value', { domain: '.yourDomain.com', path: '/a' });
 *
 * FastUtils.removeCookie('key'); // × 错误示范
 * FastUtils.getCookie('key'); // => 'value' 这样是删除不了的
 *
 * FastUtils.removeCookie('key', { domain: '.yourDomain.com', path: '/a' });
 * FastUtils.getCookie('key'); // => undefined 删除了
 * ```
 *
 * @category Cookie
 * @param key
 * @param attributes
 * @returns Cookie string removed from document.cookie
 */
function removeCookie(key, attributes) {
    return setCookie(key, '', __assign(__assign({}, (attributes || {})), { expires: -1 }));
}


// CONCATENATED MODULE: ./node_modules/@ali/fast-utils/dist/ua.js
/**
 * 浏览器UA
 * @hidden
 */
var userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
var UA = {
    /**
     * 安卓
     */
    isAndroid: /Android/i.test(userAgent),
    /**
     * iOS
     */
    isiOS: /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(userAgent),
    /**
     * 九游客户端
     */
    isNG: /ninegameclient/i.test(userAgent),
    /**
     * 九游联运SDK
     */
    isNGSdk: /ucsdk/i.test(userAgent),
    /**
     * 九游客户端-安卓
     */
    isNGAndroid: /ninegameclient\/android/i.test(userAgent),
    /**
     * 九游客户端-iOS
     */
    isNGiOS: /ninegameclient\/ios/i.test(userAgent),
    /**
     * UC内核
     */
    isUC: /UCBrowser/i.test(userAgent),
    /**
     * 微信
     */
    isWechat: /MicroMessenger/i.test(userAgent),
    /**
     * 微博
     */
    isWeiBo: /WeiBo/i.test(userAgent),
    /**
     * 钉钉
     */
    isDingTalk: /DingTalk/i.test(userAgent),
};


// CONCATENATED MODULE: ./node_modules/@ali/fast-utils/dist/loader.js
/**
 * 加载单个JS资源，并插入 `<head>`
 *
 * ```js
 * FastUtils.loadScript('...').then(function(){
 *   console.log('load success');
 * }).catch(function(err){
 *   console.error('load fail', err);
 * });
 * ```
 *
 * @category Loader
 * @param src
 * @param opts.crossOrigin 添加 crossOrigin 属性
 */
function loadScript(src, opts) {
    if (opts === void 0) { opts = { crossOrigin: '' }; }
    return new Promise(function (resolve, reject) {
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.type = 'text/javascript';
        if (opts.crossOrigin === 'anonymous' || opts.crossOrigin === 'use-credentials') {
            script.crossOrigin = opts.crossOrigin;
        }
        script.src = src;
        script.onload = function () {
            resolve();
        };
        script.onerror = function () {
            reject(new Error(src + " \u52A0\u8F7D\u5931\u8D25"));
        };
        head.appendChild(script);
    });
}
/**
 * 加载多个JS资源，并插入 `<head>`
 *
 * ```js
 * // 默认串行加载，加载完一个再加载下一个
 * FastUtils.loadScriptList({ srcList: ['...', '...'] }).then(function(){
 *   console.log('load success');
 * }).catch(function(err){
 *   console.error('load fail', err);
 * });
 *
 * // 并行加载，同时加载所有
 * FastUtils.loadScriptList({ srcList: ['...', '...'], parallel: true }).then(function(){
 *   console.log('load success');
 * }).catch(function(err){
 *   console.error('load fail', err);
 * });
 * ```
 *
 * @category Loader
 * @param params.srcList 资源数组
 * @param params.parallel 是否并行，默认否
 * @param params.srcOpts 加载参数, 默认无
 */
function loadScriptList(params) {
    if (params.srcList.length === 0)
        return Promise.reject();
    var srcOpts = params.srcOpts || {};
    if (params.srcList.length === 1) {
        return loadScript(params.srcList[0], srcOpts);
    }
    else if (params.parallel === true) {
        // 并行
        var loadPromises = params.srcList.map(function (src) { return loadScript(src, srcOpts); });
        return Promise.all(loadPromises);
    }
    else {
        // 串行
        return params.srcList.reduce(function (previousPromise, currentSrc) {
            return previousPromise.then(function () {
                return loadScript(currentSrc, srcOpts);
            });
        }, Promise.resolve());
    }
}
/**
 * 加载单个CSS资源，并插入 `<head>`
 *
 * ```js
 * FastUtils.loadStyle('...').then(function(){
 *   console.log('load success');
 * }).catch(function(err){
 *   console.error('load fail', err);
 * });
 * ```
 *
 * @category Loader
 * @param src
 */
function loadStyle(src) {
    return new Promise(function (resolve, reject) {
        var head = document.getElementsByTagName('head')[0];
        var style = document.createElement('link');
        style.rel = 'stylesheet';
        style.type = 'text/css';
        style.href = src;
        style.onload = function () {
            resolve();
        };
        style.onerror = function () {
            reject(new Error(src + " \u52A0\u8F7D\u5931\u8D25"));
        };
        head.appendChild(style);
    });
}
/**
 * 加载多个CSS资源，并插入 `<head>`
 *
 * ```js
 * // 并行加载，同时加载所有
 * FastUtils.loadStyleList({ srcList: ['...', '...'] }).then(function(){
 *   console.log('load success');
 * }).catch(function(err){
 *   console.error('load fail', err);
 * });
 * ```
 *
 * @category Loader
 * @param params.srcList 资源数组
 */
function loadStyleList(params) {
    if (params.srcList.length === 0)
        return Promise.reject();
    if (params.srcList.length === 1) {
        return loadStyle(params.srcList[0]);
    }
    else {
        // 并行
        var loadPromises = params.srcList.map(function (src) { return loadStyle(src); });
        return Promise.all(loadPromises);
    }
}
/**
 * 加载单个Image资源
 *
 * ```js
 * FastUtils.loadImage('...').then(function(img){
 *   console.log('load success');
 *   document.body.appendChild(img);
 * }).catch(function(err){
 *   console.error('load fail', err);
 * });
 * ```
 *
 * @category Loader
 * @param src
 * @return 返回 `HTMLImageElement`，可以插入 HTML
 */
function loadImage(src) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.src = src;
        img.onload = function () {
            resolve(img);
        };
        img.onerror = function () {
            reject(new Error(src + " \u52A0\u8F7D\u5931\u8D25"));
        };
    });
}
/**
 * 加载多个Image资源
 *
 * ```js
 * // 并行加载，同时加载所有
 * FastUtils.loadImageList({
 *   srcList: ['...', '...'],
 *   onProgress: function(params) {
 *     console.log('current progress:', params.percent);
 *   }
 * }).then(function(imgList){
 *   console.log('load success', imgList);
 * }).catch(function(err){
 *   console.error('load fail', err);
 * });
 * ```
 *
 * @category Loader
 * @param params.srcList 图片资源列表
 * @param params.onProgress 图片加载进度通知，可实现加载进度条
 * @return 返回 `HTMLImageElement` 列表，可以插入 HTML
 */
function loadImageList(params) {
    if (params.srcList.length === 0)
        return Promise.reject();
    // 并行
    var total = params.srcList.length;
    var completed = 0;
    var loadPromises = [];
    params.srcList.forEach(function (src) {
        var loadItem = loadImage(src);
        loadPromises.push(loadItem);
        loadItem.then(function () {
            completed++;
            if (typeof params.onProgress === 'function') {
                params.onProgress({ total: total, completed: completed, percent: completed / total });
            }
        });
    });
    return Promise.all(loadPromises);
}


// CONCATENATED MODULE: ./node_modules/@ali/fast-utils/dist/function.js
/**
 * 节流函数
 *
 * ```js
 * const throttleRet = FastUtils.throttle(function(e){
 *   console.log('throttle');
 * });
 *
 * window.addEventListener('scroll', throttleRet);
 *
 * // throttleRet 将不可再执行
 * throttleRet.cancel();
 * ```
 *
 * @category Function
 * @param callback 调用的函数
 * @param delay 延迟时间，默认200ms
 * @param callbackOptions 内部参数
 * @return 返回的值，可以调用 `cancel` 取消执行
 */
function throttle(callback, delay, callbackOptions) {
    if (delay === void 0) { delay = 200; }
    var isImmediate = true;
    var isDebounce = false;
    var timeoutID;
    var lastExec = 0;
    var ctx;
    var callbackArgs;
    var isCancelled = false;
    if (typeof callbackOptions === 'object') {
        isImmediate = 'isImmediate' in callbackOptions ? !!callbackOptions.isImmediate : isImmediate;
        isDebounce = 'isDebounce' in callbackOptions ? !!callbackOptions.isDebounce : isDebounce;
    }
    function clearExistingTimeout() {
        if (timeoutID !== undefined) {
            clearTimeout(timeoutID);
        }
    }
    function cancel() {
        clearExistingTimeout();
        lastExec = 0;
        isCancelled = true;
    }
    function exec() {
        lastExec = isImmediate ? Date.now() : 0;
        callback.apply(ctx, callbackArgs);
    }
    function wrapper() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (isCancelled)
            return;
        var now = Date.now();
        if (lastExec === 0 && isImmediate === false) {
            lastExec = now;
        }
        var elapsed = now - lastExec;
        callbackArgs = args;
        ctx = this;
        clearExistingTimeout();
        if (elapsed > delay) {
            exec();
        }
        else {
            if (isDebounce) {
                clearExistingTimeout();
                lastExec = now;
            }
            timeoutID = setTimeout(exec, delay - elapsed);
        }
    }
    wrapper.cancel = cancel;
    return wrapper;
}
/**
 * 防抖函数
 *
 * ```js
 * const debounceRet = FastUtils.debounce(function(e){
 *   console.log('debounce');
 * });
 *
 * window.addEventListener('scroll', debounceRet);
 *
 * // debounceRet 将不可再执行
 * debounceRet.cancel();
 * ```
 *
 * @category Function
 * @param callback 调用的函数
 * @param delay 延迟时间，默认200ms
 * @param callbackOptions 内部参数
 * @return 返回的值，可以调用 `cancel` 取消执行
 */
function debounce(callback, delay, callbackOptions) {
    if (delay === void 0) { delay = 200; }
    var isImmediate = true;
    var isDebounce = true;
    if (typeof callbackOptions === 'object') {
        isImmediate = 'isImmediate' in callbackOptions ? !!callbackOptions.isImmediate : isImmediate;
        isDebounce = 'isDebounce' in callbackOptions ? !!callbackOptions.isDebounce : isDebounce;
    }
    return throttle(callback, delay, { isDebounce: isDebounce, isImmediate: isImmediate });
}
/**
 * 版本号比较
 *
 * ```js
 * FastUtils.compareVersion('1.0.0', '=', '1.0.0'); // => true
 * FastUtils.compareVersion('1.1.1.1', '>=', '1.0.0'); // => true
 * FastUtils.compareVersion('1.1.0', '<', '1.0.0'); // => false
 * ```
 *
 * @category Function
 * @param leftVersion
 * @param compareFlag 比较符号：'>', '>=', '=', '<=', '<'
 * @param rightVersion
 */
function compareVersion(leftVersion, compareFlag, rightVersion) {
    var leftVersionArr = leftVersion.split('.').map(function (i) { return parseInt(i, 10); });
    var rightVersionArr = rightVersion.split('.').map(function (i) { return parseInt(i, 10); });
    for (var i = 0; i < Math.max(leftVersionArr.length, rightVersionArr.length); i++) {
        var currentLeft = leftVersionArr[i];
        var currentRight = rightVersionArr[i];
        if (isNaN(currentLeft) || isNaN(currentRight)) {
            return false;
        }
        if ((currentLeft && !currentRight && currentLeft > 0) || currentLeft > currentRight) {
            return compareFlag === '>' || compareFlag === '>=';
        }
        else if ((currentRight && !currentLeft && currentRight > 0) || currentLeft < currentRight) {
            return compareFlag === '<' || compareFlag === '<=';
        }
    }
    return compareFlag === '=' || compareFlag === '<=' || compareFlag === '>=';
}
/**
 * 左填充字符串到指定长度
 *
 * ```js
 * FastUtils.padStart('1', 2, '0'); // => '01'
 * FastUtils.padStart('10', 2, '0'); // => '10'
 * ```
 *
 * @category Function
 * @param str 原字符串
 * @param length 指定长度
 * @param pad 填充的字符串
 */
function padStart(str, length, pad) {
    var s = String(str);
    if (!s || s.length >= length)
        return s;
    return "" + Array(length + 1 - s.length).join(pad) + str;
}


// CONCATENATED MODULE: ./node_modules/@ali/fast-utils/dist/time-date.js


/**
 * 解析输入 => `Date`
 * @category TimeDate
 * @param value
 * 兼容 iOS 日期格式问题 `value = value.replace(/-/g, '/');`
 */
function parseDate(value) {
    var date;
    if (value instanceof Date) {
        date = value;
    }
    else if (typeof value === 'number') {
        date = new Date(value);
    }
    else if (typeof value === 'string') {
        if (UA.isiOS) {
            // iOS 日期格式兼容
            value = value.replace(/-/g, '/');
        }
        date = new Date(value);
    }
    else {
        date = new Date();
    }
    return date;
}
/**
 * 获取 `Date` 详细信息
 * @category TimeDate
 * @param date
 * @hidden
 */
function getDateData(date) {
    var data = {
        $y: date.getFullYear(),
        $M: date.getMonth(),
        $D: date.getDate(),
        $W: date.getDay(),
        $H: date.getHours(),
        $m: date.getMinutes(),
        $s: date.getSeconds(),
        $ms: date.getMilliseconds(),
    };
    return data;
}
/**
 * 日期格式化正则
 * @category TimeDate
 * @internal
 */
var REGEX_FORMAT = /Y{2,4}|M{1,4}|D{1,2}|h{1,2}|m{1,2}|s{1,2}/g;
/**
 * 格式化日期
 *
 * | 占位符  | 输出   | 备注               |
 * | ------ | ----- | ------------------|
 * | `YY`   | 18    | 两位数的年份         |
 * | `YYYY` | 2018  | 四位数的年份         |
 * | `M`    | 1-12  | 月份，从 1 开始      |
 * | `MM`   | 01-12 | 月份，两位数         |
 * | `D`    | 1-31  | 月份里的一天         |
 * | `DD`   | 01-31 | 月份里的一天，两位数  |
 * | `h`    | 0-23  | 小时               |
 * | `hh`   | 00-23 | 小时，两位数         |
 * | `m`    | 0-59  | 分钟               |
 * | `mm`   | 00-59 | 分钟，两位数         |
 * | `s`    | 0-59  | 秒                 |
 * | `ss`   | 00-59 | 秒 两位数           |
 *
 *
 * ```js
 * FastUtils.formatDate(1591950794000); // => '2020-06-12 16:33:14'
 *
 * // 格式化当前时间
 * FastUtils.formatDate();
 * ```
 *
 * @category TimeDate
 * @param value 日期输入
 * @param formatStr 格式化占位符
 */
function formatDate(value, formatStr) {
    if (value === void 0) { value = new Date(); }
    if (formatStr === void 0) { formatStr = 'YYYY-MM-DD hh:mm:ss'; }
    var date = parseDate(value);
    var dateData = getDateData(date);
    var matches = {
        YY: String(dateData.$y).slice(-2),
        YYYY: dateData.$y,
        M: dateData.$M + 1,
        MM: padStart(dateData.$M + 1, 2, '0'),
        D: dateData.$D,
        DD: padStart(dateData.$D, 2, '0'),
        h: String(dateData.$H),
        hh: padStart(dateData.$H, 2, '0'),
        m: String(dateData.$m),
        mm: padStart(dateData.$m, 2, '0'),
        s: String(dateData.$s),
        ss: padStart(dateData.$s, 2, '0'),
    };
    return formatStr.replace(REGEX_FORMAT, function (match) {
        return matches[match];
    });
}
/**
 * 不同时间单位的单位秒数
 * @category TimeDate
 */
var timeUnitSecond = {
    minute: 60,
    hour: 60 * 60,
    day: 60 * 60 * 24,
    month: 60 * 60 * 24 * 30,
    year: 60 * 60 * 24 * 365,
};
/**
 * 解析剩余时间
 *
 * ```
 * FastUtils.parseRemainTime({ remainSecond: 100000 }); // => {second:40,minute:46,hour:27,day:0,month:0,year:0}
 * FastUtils.parseRemainTime({ remainSecond: 100000, maxTimeUnit: 'day' }); // => {second:40,minute:46,hour:3,day:1,month:0,year:0}
 * FastUtils.parseRemainTime({ remainSecond: 10000000, maxTimeUnit: 'day' }); // => {second:40,minute:46,hour:17,day:115,month:0,year:0}
 * FastUtils.parseRemainTime({ remainSecond: 10000000, maxTimeUnit: 'month' }); // => {second:40,minute:46,hour:17,day:25,month:3,year:0}
 * FastUtils.parseRemainTime({ remainSecond: 100000000, maxTimeUnit: 'year' }); // => {second:40,minute:46,hour:9,day:2,month:2,year:3}
 * ```
 *
 * @category TimeDate
 * @param options
 * - remainSecond 剩余时间，单位: 秒；
 * - maxTimeUnit 最高解析到哪个时间单位，默认为 `hour`；
 */
function parseRemainTime(options) {
    var remainTime = {
        second: 0,
        minute: 0,
        hour: 0,
        day: 0,
        month: 0,
        year: 0,
    };
    if (!options || !options.remainSecond || options.remainSecond <= 0)
        return remainTime;
    if (typeof options.maxTimeUnit === 'undefined') {
        options.maxTimeUnit = 'hour';
    }
    var maxTimeUnit = options.maxTimeUnit;
    var remainSecond = options.remainSecond;
    var isMatchTimeUnit = false;
    if (isMatchTimeUnit || maxTimeUnit === 'year') {
        var oneYearSecond = timeUnitSecond.year;
        remainTime.year = parseInt(String(remainSecond / oneYearSecond), 10);
        remainSecond = remainSecond - remainTime.year * oneYearSecond;
        isMatchTimeUnit = true;
    }
    if (isMatchTimeUnit || maxTimeUnit === 'month') {
        var oneMonthSecond = timeUnitSecond.month;
        remainTime.month = parseInt(String(remainSecond / oneMonthSecond), 10);
        remainSecond = remainSecond - remainTime.month * oneMonthSecond;
        isMatchTimeUnit = true;
    }
    if (isMatchTimeUnit || maxTimeUnit === 'day') {
        var oneDaySecond = timeUnitSecond.day;
        remainTime.day = parseInt(String(remainSecond / oneDaySecond), 10);
        remainSecond = remainSecond - remainTime.day * oneDaySecond;
        isMatchTimeUnit = true;
    }
    if (isMatchTimeUnit || maxTimeUnit === 'hour') {
        var oneHourSecond = timeUnitSecond.hour;
        remainTime.hour = parseInt(String(remainSecond / oneHourSecond), 10);
        remainSecond = remainSecond - remainTime.hour * oneHourSecond;
        isMatchTimeUnit = true;
    }
    if (isMatchTimeUnit || maxTimeUnit === 'minute') {
        var oneMinuteSecond = timeUnitSecond.minute;
        remainTime.minute = parseInt(String(remainSecond / oneMinuteSecond), 10);
        remainSecond = remainSecond - remainTime.minute * oneMinuteSecond;
        isMatchTimeUnit = true;
    }
    if (isMatchTimeUnit || maxTimeUnit === 'second') {
        remainTime.second = remainSecond;
        isMatchTimeUnit = true;
    }
    return remainTime;
}
/**
 * 倒计时
 *
 * ```js
 * const timer = FastUtils.countDown({
 *   remainSecond: 100,
 *   maxTimeUnit: 'hour',
 *   onUpdate(remainTimeData) {
 *     console.log(remainTimeData);
 *   },
 *   onFinish() {
 *     console.log('finish');
 *   }
 * });
 *
 * // 取消倒计时
 * timer.cancel();
 * ```
 *
 * @category TimeDate
 * @param options
 * - remainSecond 剩余时间，单位: 秒；
 * - maxTimeUnit 最高解析到哪个时间单位，默认为 `hour`；
 * - onUpdate 倒计时更新通知，每秒调用一次，传入 [[IRemainTime]] 信息
 * - onFinish 倒计时结束通知
 * @return 返回 `cancel` 函数，可取消倒计时
 */
function countDown(options) {
    var remainSecond = options.remainSecond;
    var timerId;
    function cancel() {
        if (timerId) {
            clearInterval(timerId);
        }
    }
    // 马上触发第一次更新
    if (typeof options.onUpdate === 'function') {
        options.onUpdate(parseRemainTime({ remainSecond: remainSecond, maxTimeUnit: options.maxTimeUnit }));
    }
    timerId = setInterval(function () {
        remainSecond--;
        if (typeof options.onUpdate === 'function') {
            options.onUpdate(parseRemainTime({ remainSecond: remainSecond, maxTimeUnit: options.maxTimeUnit }));
        }
        if (remainSecond <= 0) {
            typeof options.onFinish === 'function' && options.onFinish();
            cancel();
        }
    }, 1000);
    return {
        cancel: cancel,
    };
}


// CONCATENATED MODULE: ./node_modules/@ali/fast-utils/dist/url-query.js
var url_query___assign = (this && this.__assign) || function () {
    url_query___assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return url_query___assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/**
 * 解析默认属性
 * @hidden
 */
var DEFAULT_PARSE_OPTIONS = {
    decode: true,
    parseArray: true,
};
/**
 * 解析 queryParam 字符串
 *
 * ```js
 * FastUtils.parseQueryParam('?a=1&b=2'); // => {a: "1", b: "2"}
 * FastUtils.parseQueryParam('a=1&b=2'); // => {a: "1", b: "2"}
 *
 * // 处理多个同名参数
 * FastUtils.parseQueryParam('?a=1&b=2&b=3'); // => {a: "1", b: ["2", "3"]}
 * FastUtils.parseQueryParam('?a=1&b=2&b=3', { parseArray: false }); // => {a: "1", b: "2"}
 *
 * // 其他特殊情况
 * FastUtils.parseQueryParam('?a'); // => {a: null}
 * FastUtils.parseQueryParam('?a='); // => {a: ""}
 * FastUtils.parseQueryParam(''); // => {}
 * ```
 *
 * @category UrlQuery
 * @param input queryParam 输入
 * @param options
 * - `decode`：默认为 `true`
 * - `parseArray`：默认为 `true`
 */
function parseQueryParam(input, options) {
    var result = {};
    options = url_query___assign(url_query___assign({}, DEFAULT_PARSE_OPTIONS), options);
    if (typeof input !== 'string') {
        return result;
    }
    input = input.trim().replace(/^[?#&]/, '');
    if (!input) {
        return result;
    }
    for (var _i = 0, _a = input.split('&'); _i < _a.length; _i++) {
        var param = _a[_i];
        var _b = param.split('='), key = _b[0], value = _b[1];
        if (value === undefined) {
            value = null;
        }
        if (options.decode) {
            typeof key === 'string' && (key = decodeURIComponent(key));
            typeof value === 'string' && (value = decodeURIComponent(value));
        }
        if (result[key] === undefined) {
            result[key] = value;
        }
        else if (options.parseArray) {
            result[key] = [].concat(result[key], value);
        }
    }
    return result;
}
/**
 * 序列化默认属性
 * @hidden
 */
var DEFAULT_STRINGIFY_OPTIONS = {
    encode: true,
    skipEmptyString: false,
    addQuestionMark: false,
};
/**
 * 序列化 queryParam 对象
 *
 * ```js
 * FastUtils.stringifyQueryParam({ a: "1", b: "2" }); // => 'a=1&b=2'
 * FastUtils.stringifyQueryParam({ a: "1", b: ["2", "3"] }); // => 'a=1&b=2&b=3'
 * FastUtils.stringifyQueryParam({ a: "1", b: "2" }, { addQuestionMark: true }); // => '?a=1&b=2'
 *
 * // 是否跳过空字符串
 * FastUtils.stringifyQueryParam({ a: "", b: "" }); // => 'a=&b='
 * FastUtils.stringifyQueryParam({ a: "", b: "" }, { skipEmptyString: true }); // => ''
 *
 * // 其他情况
 * FastUtils.stringifyQueryParam({ a: null, b: undefined }); // => ''
 * ```
 *
 * @category UrlQuery
 * @param queryParamObj
 * @param options
 * - `encode`：默认为 `true`
 * - `skipEmptyString`：默认为 `false`
 * - `addQuestionMark`：默认为 `false`
 */
function stringifyQueryParam(queryParamObj, options) {
    var result = '';
    options = url_query___assign(url_query___assign({}, DEFAULT_STRINGIFY_OPTIONS), options);
    if (!queryParamObj) {
        return result;
    }
    var shouldFilter = function (key) {
        return queryParamObj[key] === null ||
            queryParamObj[key] === undefined ||
            (options.skipEmptyString && queryParamObj[key] === '');
    };
    var queryParamObjFilter = {};
    for (var _i = 0, _a = Object.keys(queryParamObj); _i < _a.length; _i++) {
        var key = _a[_i];
        if (!shouldFilter(key)) {
            queryParamObjFilter[key] = queryParamObj[key];
        }
    }
    result = Object.keys(queryParamObjFilter)
        .map(function (key) {
        var value = queryParamObjFilter[key];
        if (Array.isArray(value)) {
            return value
                .reduce(function (acc, value) {
                if (value === undefined ||
                    value === null ||
                    (options.skipEmptyString && value === '')) {
                    return acc;
                }
                if (options.encode) {
                    key = encodeURIComponent(key);
                    value = encodeURIComponent(value);
                }
                return __spreadArrays(acc, [[key, '=', value].join('')]);
            }, [])
                .join('&');
        }
        if (options.encode) {
            key = encodeURIComponent(key);
            value = encodeURIComponent(value);
        }
        return key + '=' + value;
    })
        .filter(function (x) { return x.length > 0; })
        .join('&');
    if (options.addQuestionMark && result.length > 0) {
        result = "?" + result;
    }
    return result;
}
/**
 * 获取 url 中 query 部分正则
 * @category UrlQuery
 * @hidden
 */
var QUERY_REGEX = /\?[^#]+/;
/**
 * 将 url 切分，便于操作
 * @category UrlQuery
 * @param url
 * @private
 */
function _splitUrl(url) {
    var result = { urlPart: '', queryPart: '', hashPart: '' };
    if (!url)
        return result;
    var urlArr = url.split('');
    var queryIndex = urlArr.indexOf('?');
    var hashIndex = urlArr.indexOf('#');
    if (hashIndex > -1) {
        result.hashPart = urlArr.splice(hashIndex).join('');
    }
    if (queryIndex > -1) {
        result.queryPart = urlArr.splice(queryIndex).join('');
    }
    result.urlPart = urlArr.join('');
    return result;
}
/**
 * 对外暴露 _splitUrl 方法
 *
 * ```js
 * FastUtils.splitUrl('http://127.0.0.1:8080/?query=1#hash'); // => {urlPart: "http://127.0.0.1:8080/", queryPart: "?query=1", hashPart: "#hash"}
 * ```
 * @category UrlQuery
 * @param url 默认为 `window.location.href`
 */
function splitUrl(url) {
    if (url === void 0) { url = window.location.href; }
    return _splitUrl(url);
}
/**
 * 获取 queryParam
 * @category UrlQuery
 * @param key
 * @param url
 * @param getArray
 * @private
 */
function _getQueryParam(key, url, getArray) {
    var queryParamObj = parseQueryParam(_splitUrl(url).queryPart, {
        parseArray: getArray,
    });
    return queryParamObj[key];
}
/**
 * 指定 key 获取 queryParam 的值
 *
 * ```js
 * FastUtils.getQueryParam('key', 'https://a.com?key=1'); // => '1'
 * FastUtils.getQueryParam('key', 'https://a.com?key='); // => ''
 * FastUtils.getQueryParam('key', 'https://a.com?key'); // => null
 * FastUtils.getQueryParam('key', 'https://a.com'); // => undefined
 *
 * // 遇到两个同名 key，只返回第一个值
 * FastUtils.getQueryParam('key', 'https://a.com?key=1&key=2'); // => '1'
 * ```
 *
 * @category UrlQuery
 * @param key
 * @param url 默认为 `window.location.href`
 */
function getQueryParam(key, url) {
    if (url === void 0) { url = window.location.href; }
    return _getQueryParam(key, url, false);
}
/**
 * 指定 key 获取 queryParam 的值
 *
 * 遇到多个同名 key 时会返回数组，其他和 [[getQueryParam]] 表现一致
 *
 * ```js
 * FastUtils.getQueryParams('key', 'https://a.com?key=1&key=2'); // => ['1', '2']
 * ```
 *
 * @category UrlQuery
 * @param key
 * @param url 默认为 `window.location.href`
 */
function getQueryParams(key, url) {
    if (url === void 0) { url = window.location.href; }
    return _getQueryParam(key, url, true);
}
/**
 * 指定 key 设置 queryParam 的值
 *
 * ```js
 * FastUtils.setQueryParam('key', '1', 'https://a.com'); // => "https://a.com?key=1"
 * FastUtils.setQueryParam('key', ['1', '2'], 'https://a.com'); // => "https://a.com?key=1&key=2"
 *
 * // 已有的同名 key 会被覆盖
 * FastUtils.setQueryParam('key', '2', 'https://a.com?key=1'); // => "https://a.com?key=2"
 *
 * // 其他情况
 * FastUtils.setQueryParam('key', '', 'https://a.com'); // => "https://a.com?key="
 * FastUtils.setQueryParam('key', null, 'https://a.com'); // => "https://a.com"
 * FastUtils.setQueryParam('key', undefined, 'https://a.com'); // => "https://a.com"
 * ```
 *
 * @category UrlQuery
 * @param key
 * @param value
 * @param url 默认为 `window.location.href`
 */
function setQueryParam(key, value, url) {
    if (url === void 0) { url = window.location.href; }
    var urlObj = _splitUrl(url);
    var queryParamObj = parseQueryParam(urlObj.queryPart, { parseArray: true });
    queryParamObj[key] = value;
    return "" + urlObj.urlPart + stringifyQueryParam(queryParamObj, {
        addQuestionMark: true,
    }) + urlObj.hashPart;
}
/**
 * 指定 key 移除 queryParam 的值
 *
 * ```js
 * FastUtils.removeQueryParam('key', 'https://a.com?key=1&key=2&other=3'); // => "https://a.com?other=3"
 * ```
 *
 * @category UrlQuery
 * @param key
 * @param url 默认为 `window.location.href`
 */
function removeQueryParam(key, url) {
    if (url === void 0) { url = window.location.href; }
    var urlObj = _splitUrl(url);
    var queryParamObj = parseQueryParam(urlObj.queryPart, { parseArray: true });
    delete queryParamObj[key];
    return "" + urlObj.urlPart + stringifyQueryParam(queryParamObj, {
        addQuestionMark: true,
    }) + urlObj.hashPart;
}


// CONCATENATED MODULE: ./node_modules/@ali/fast-utils/dist/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setCookie", function() { return setCookie; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getCookie", function() { return getCookie; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "removeCookie", function() { return removeCookie; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "UA", function() { return UA; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "loadScript", function() { return loadScript; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "loadScriptList", function() { return loadScriptList; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "loadStyle", function() { return loadStyle; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "loadStyleList", function() { return loadStyleList; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "loadImage", function() { return loadImage; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "loadImageList", function() { return loadImageList; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "debounce", function() { return debounce; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "throttle", function() { return throttle; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "compareVersion", function() { return compareVersion; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "padStart", function() { return padStart; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "parseDate", function() { return parseDate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "formatDate", function() { return formatDate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "parseRemainTime", function() { return parseRemainTime; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "countDown", function() { return countDown; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "parseQueryParam", function() { return parseQueryParam; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "stringifyQueryParam", function() { return stringifyQueryParam; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getQueryParam", function() { return getQueryParam; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getQueryParams", function() { return getQueryParams; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setQueryParam", function() { return setQueryParam; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "removeQueryParam", function() { return removeQueryParam; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "splitUrl", function() { return splitUrl; });








/***/ }),

/***/ "Hpnf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__("D8yW"),
    getCookie = _require.getCookie;

var CleanLogin = function () {
  function CleanLogin() {
    _classCallCheck(this, CleanLogin);

    this.Init();
  }

  _createClass(CleanLogin, [{
    key: 'GetHosts',
    value: function GetHosts(from) {
      var target = window.location.href;
      if (target.indexOf('?') > -1) {
        var tmpArr = target.split('?');
        target = '' + tmpArr[0] + encodeURIComponent('?' + tmpArr[1]);
      }
      var curURrl = 'https://www.9game.cn/login/rcd?action=' + from + '&redirect=' + encodeURIComponent(target);

      return encodeURIComponent(curURrl);
    }
  }, {
    key: 'Init',
    value: function Init() {
      var ng_session_id = getCookie('ng_session_id') || '';
      var current_uid = getCookie('current_uid') || '';
      var current_nickname = getCookie('current_nickname') || '';
      if (ng_session_id) {
        if (current_uid == '' || current_uid == '0' || current_nickname == '') {
          $.ajax({
            type: 'GET',
            url: 'https://www.9game.cn/loginInfoSync?retUrl=' + this.GetHosts('login'),
            data: {},
            timeout: 4000,
            success: function success(data, statusText) {
              console.log('data ==>', data);
              console.log('statusText ==>', statusText);
            },
            error: function error() {}
          });
        }
      }
    }
  }]);

  return CleanLogin;
}();

new CleanLogin();

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/rclearLogin/index.89ab5ac1.js